// extracted by mini-css-extract-plugin
export default {"artsPage":"Arts_artsPage__NCfUq","pageTitle":"Arts_pageTitle__-QQbA","contentSection":"Arts_contentSection__x5Rvm"};